import * as React from 'react';
import DeleteIcon from "@material-ui/icons/Delete";
import SaveIcon from "@material-ui/icons/Save";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import Tooltip from "@mui/material/Tooltip";
import i18next from 'i18next';
import { userActions } from "../../_actions";
import { userService } from "../../_services";
import InputI18N from "../../_components/InputI18N";
import Collapsed from "../../_components/Collapsed";
import TicketTypeItemForm from './TicketTypeItemForm';
import ConferenceAnketa from "../ConferenceAnketa/ConferenceAnketa";
import { premiumStateText } from "../../_helpers";

export function hasTicketName(ticketType, isMultilang) {
  if (!isMultilang) return ticketType.name != "";
  const i18n = ticketType.name_i18n || {};
  return !!(i18n["ru"] || i18n["en"] || i18n["cn"]);
}

export function buildTicketTypePayload(ticketType, conferenceId, isMultilang) {
  const post_data = {
    conference_id: conferenceId,
    required_anketa: ticketType.required_anketa,
    optional_anketa: ticketType.optional_anketa,
    exponent: ticketType.exponent,
    invoice_payment: !!ticketType.invoice_payment,
  };

  if (isMultilang) {
    post_data.name_i18n = ticketType.name_i18n;
    post_data.name =
      ticketType.name_i18n["ru"] ??
      ticketType.name_i18n["en"] ??
      ticketType.name_i18n["cn"];
  } else {
    post_data.name = ticketType.name;
  }

  if (ticketType.cost > 0) post_data.cost = ticketType.cost;
  else post_data.cost = "";

  return post_data;
}

export default function TicketTypeItem(props) {
  const saveTicket = () => {
    if (!conferenceId) return;

    const ticketType = { ...ticketTypes[index] };

    if (hasTicketName(ticketType, isMultilang)) {
      const ticketId = ticketType.id;
      const post_data = buildTicketTypePayload(ticketType, conferenceId, isMultilang);

      stateSetter('loadingTickets', true);

      if (ticketId > 0) {
        userService.patchWrapperBody(
          `api/ticket-type/${ticketId}`,
          post_data,
          () => {
            getTickets(conferenceId);
          },
          (error) => {
            // Причину отказа уже показал снэкбаром patchWrapperBody; перечитываем
            // типы, чтобы галочка вернулась в сохранённое на сервере положение.
            if (error?.response?.data?.message === "ticket_type_exponent_locked") {
              getTickets(conferenceId);
              return;
            }
            if (error != "") {
              stateSetter('loadingTickets', false);
              dispatch(
                userActions.set_error(i18next.t("cant_execute_request"))
              );
            }
          }
        );
      } else {
        userService.postWrapper(
          "api/ticket-type",
          post_data,
          data => {
            getTickets(conferenceId);
          },
          error => {
            if (error != "") {
              dispatch(
                userActions.set_error(i18next.t("cant_execute_request"))
              );
            }
          }
        );
      }
    }
  };

  const delTicket = () => {
    const tmp_t = { ...ticketTypes[index] };
    const ticketId = tmp_t.id;

    if (ticketId > 0) {
      stateSetter('loadingTickets', true);

      userService.delWrapper(
        `api/ticket-type/${ticketId}`,
        data => {
          stateSetter('loadingTickets', false);
          getTickets(conferenceId);
        },
        (error) => {
          if (error !== "") {
            stateSetter('loadingTickets', false);
            dispatch(userActions.set_error(error));
          }
        }
      );
    } else {
      ticketTypes.splice(index, 1);
      stateSetter('tickets_tmp', ticketTypes);
    }
  };

  const editTicketPrice = val => {
    if (val != null) {
      if (index >= 0) {
        const tmp_obj = { ...ticketTypes[index] };
        tmp_obj.cost = val;

        ticketTypes[index] = { ...tmp_obj };
        stateSetter('tickets_tmp', ticketTypes);
      }
    }
  };

  const editTicketI18N = (val, tabName) => {
    if (val != null) {
      if (index >= 0) {
        const tmp_obj = { ...ticketTypes[index] };

        let obj_name = tmp_obj.name_i18n;
        obj_name[tabName] = val;

        if (isMultilang) tmp_obj.name_i18n = { ...obj_name };
        else tmp_obj.name = val;

        ticketTypes[index] = { ...tmp_obj };
        stateSetter('tickets_tmp', ticketTypes);
      }
    }
  };

  const toggleExponentMode = () => {
    const currentTicket = { ...ticketTypes[index] };
    currentTicket.exponent = !currentTicket.exponent;
    ticketTypes[index] = { ...currentTicket };
    stateSetter('tickets_tmp', ticketTypes);
  };

  const toggleInvoicePayment = () => {
    const currentTicket = { ...ticketTypes[index] };
    currentTicket.invoice_payment = !currentTicket.invoice_payment;
    ticketTypes[index] = { ...currentTicket };
    stateSetter('tickets_tmp', ticketTypes);
    saveTicket();
  };

  const showTextForBuy = () => {
    dispatch(
      userActions.set_error(i18next.t("for_ticket_paid_write_to_nc"), "info")
    );
  };

  const anketaSetter = (anketaKey, anketa) => {
    const ticketType = { ...ticketTypes[index] };
    if (anketaKey == 'optionalAnketa') {
      ticketType.optional_anketa = anketa;
    } else {
      ticketType.required_anketa = anketa;
    }
    ticketTypes[index] = { ...ticketType };
    stateSetter('tickets_tmp', ticketTypes);
  };

  let { ticketTypes } = props;
  const { dispatch, conferenceId, isMultilang, getTickets, stateSetter, langList, premiumState, index, item, allAnketaFields } = props;

  return (<div>
    <div class="form__group-rows">
      <div class="form__group-row">
        <InputI18N
          type="text"
          onChange={(e, tabName) =>
            editTicketI18N(
              e.target.value,
              tabName
            )
          }
          class="form__input"
          placeholder={i18next.t("name")}
          value={
            isMultilang ? item.name_i18n : item.name
          }
          langList={langList}
          isMultilang={isMultilang}
        />
      </div>
      {/* Подпись и галочка в одну строку по центру: колонкой текст «参与者»
          висел над чекбоксом мимо строки соседних полей (пункт 73 QA-таблицы). */}
      <div style={{ flexDirection: "row", alignItems: "center", display: "flex", minWidth: 0 }}>
        <div style={{ whiteSpace: "nowrap" }}>{i18next.t("exponent")}</div>
        {/* Галочка делает владельцев билетов экспонентами (поиск экспонентов, встречи
            у стенда): переключить её у выданных билетов — незаметно сменить им роль.
            Бэк отклоняет такую правку, has_active_tickets приходит в списке типов.
            enterTouchDelay={0} — чтобы подсказка открывалась тапом в WebView. */}
        <Tooltip
          title={item.has_active_tickets ? i18next.t("ticket_type_exponent_locked") : ""}
          enterTouchDelay={0}
          leaveTouchDelay={5000}
          arrow
        >
          <span>
            <FormControlLabel
              control={
                <Checkbox
                  color="default"
                  checked={item.exponent}
                  disabled={!!item.has_active_tickets}
                  onClick={toggleExponentMode}
                />
              }
            />
          </span>
        </Tooltip>
      </div>
      <div
        class="form__group-row"
        style={{ marginTop: isMultilang ? 45 : 0 }}
        onBlur={saveTicket}
      >
        {/* Подпись обязательна: в поле уже лежит цена «0», из-за чего плейсхолдер
            не виден, и серый прямоугольник с нулём принимали за количество билетов. */}
        <label className="form__label">{i18next.t("price")}</label>
        {/* Цена редактируема только при активной опции «Без ограничений» (премиуме);
            premiumState — объект {status, price?, until?} или sentinel «». */}
        {!premiumState || premiumState.status !== "already" ? (
          <>
            <input
              type="text"
              readonly="readonly"
              onClick={showTextForBuy}
              style={{ backgroundColor: "#D3D4D4" }}
              className="form__input"
              placeholder={i18next.t("price")}
              value={item.cost}
            />
            {/* Причина блокировки — сразу под полем, а не только снеком по клику:
                иначе поле выглядит просто сломанным. */}
            <div style={{ fontSize: 12, marginTop: 4, opacity: 0.7 }}>
              {premiumStateText(premiumState && premiumState.status)}
            </div>
          </>
        ) : (
          <input
            type="text"
            className="form__input"
            placeholder={i18next.t("price")}
            value={item.cost}
            onChange={(e) =>
              editTicketPrice(e.target.value)
            }
          />
        )}
      </div>
      {/* Обе иконки в одном контейнере: раздельными блоками по 30px их разносило
          переносом строки на узком экране, и между «сохранить» и «удалить»
          оказывалась половина карточки (пункт 80 QA-таблицы). */}
      <div
        style={{
          display: "flex",
          gap: 10,
          alignItems: "flex-start",
          flexShrink: 0,
          marginTop: isMultilang ? 45 : 0,
        }}
      >
        <SaveIcon
          onClick={saveTicket}
          width="15"
          height="15"
        />
        <DeleteIcon
          onClick={delTicket}
          width="15"
          height="15"
        />
      </div>
    </div>
    {item.id > 0 && <Collapsed title={i18next.t("advanced_ticket_settings")} content={<div>
      <FormControlLabel
        control={
          <Checkbox
            color="default"
            checked={!!item.invoice_payment}
            onClick={toggleInvoicePayment}
          />
        }
        label={i18next.t("invoice_payment")}
      />
      <TicketTypeItemForm item={item} />
      <ConferenceAnketa
        requiredAnketa={item.required_anketa ?? []}
        optionalAnketa={item.optional_anketa ?? []}
        allAnketaFields={allAnketaFields}
        stateSetter={anketaSetter}
      />
    </div>} />}
  </div>);
}
